import calendarSeasons from './data/calendarSeasons.json';
import guests from './data/guests.json';
import holidayDates from './data/holidayDate.json';
import parks from './data/parks.json';
import price from './data/price.json';
import rooms from './data/rooms.json';
import tourerLengths from './data/tourerLength.json';
import tourerTypes from './data/tourerType.json';
import touringDates from './data/touringDate.json';
import isContain from './helpers/isContain';
export const defaultData = Object.freeze({
    parks,
    price,
    rooms,
    guests,
    tourerLengths,
    tourerTypes,
    holidayDates,
    touringDates,
    calendarSeasons,
});
export const getListWithFilter = (filters, touringFilter) => {
    // Sort parks by region
    const sortedParks = defaultData.parks.sort((a, b) => {
        if (a.regionCode < b.regionCode)
            return -1;
        if (a.regionCode > b.regionCode)
            return 1;
        return 0;
    });
    // Add opening/closing seasons to each park
    const parks = sortedParks.map((park) => {
        var _a;
        const season = (_a = defaultData.calendarSeasons.find((item) => park.code === item.code)) === null || _a === void 0 ? void 0 : _a.season;
        return Object.assign(Object.assign({}, park), { season });
    });
    const isContainTourerType = (park, type, size) => {
        var _a;
        if (!type || !size)
            return true;
        return (_a = park === null || park === void 0 ? void 0 : park.allowedLength) === null || _a === void 0 ? void 0 : _a[type].includes(size);
    };
    const regions = parks.reduce((prev, next) => {
        const contain = isContain(next, filters);
        if (!contain)
            return prev;
        return Object.assign(Object.assign({}, prev), { [next.regionCode]: {
                name: next.regionName,
                code: next.regionCode,
                parks: [
                    ...(prev[next.regionCode] && prev[next.regionCode].parks
                        ? prev[next.regionCode].parks
                        : []),
                    ...(isContainTourerType(next, touringFilter === null || touringFilter === void 0 ? void 0 : touringFilter.type, touringFilter === null || touringFilter === void 0 ? void 0 : touringFilter.size) ? [next] : []),
                ],
            } });
    }, {});
    return Object.keys(regions)
        .filter((region) => regions[region].parks.length)
        .map((regionName) => regions[regionName])
        .sort((a, b) => b.code - a.code);
};
export const getAllRegions = () => parks
    .map((park) => ({
    name: park.regionCode,
    code: park.regionCode,
}))
    .reduce((arr, item) => {
    const exists = !!arr.find((x) => x.code === item.code);
    if (!exists) {
        return [...arr, item];
    }
    return arr;
}, []);
export const getAllParks = () => getListWithFilter();
export const getAllParksByRegion = (regionCode) => getListWithFilter({ regionCode });
export const getAllHolidaysParksByRegion = (regionCode) => getListWithFilter({ holidaysAvailable: true, regionCode });
export const getAllOwnershipParksByRegion = (regionCode) => getListWithFilter({ ownershipAvailable: true, regionCode });
export const getAllTouringParksByRegion = (regionCode, type, size) => getListWithFilter(Object.assign(Object.assign({ touringAvailable: true }, (type ? { [type]: true } : {})), { regionCode }), { type, size });
export const getAllTouringParksByTourerType = (tourerType) => getListWithFilter({ [tourerType]: true });
export const getAllOwnershipParks = () => getListWithFilter({ ownershipAvailable: true });
/**
 * @deprecated This has now been replaced throughout the shared UI library with getRegions
 */
export const getAllHolidaysParks = () => getListWithFilter({ holidaysAvailable: true });
export const getTourerParkCodes = () => parks.filter((park) => park.Tourer).map((park) => park.code);
export const getPrices = () => defaultData.price;
export const getRooms = () => defaultData.rooms;
export const getGuests = () => defaultData.guests;
export const getPriceName = (value) => { var _a; return (_a = defaultData.price.find((price) => price.value === value)) === null || _a === void 0 ? void 0 : _a.name; };
export const getRoomName = (value) => { var _a; return (_a = defaultData.rooms.find((room) => room.value === value)) === null || _a === void 0 ? void 0 : _a.name; };
export const getParkNameByCode = (code) => {
    const park = defaultData.parks.find((park) => park.code === code);
    return (park === null || park === void 0 ? void 0 : park.name) || null;
};
export const getParkByCode = (code) => {
    const park = defaultData.parks.find((park) => park.code === code);
    return park || null;
};
export const getParksNamesByArray = (parkNames) => parkNames && parkNames.length
    ? parkNames.map((location) => getParkNameByCode(location)).join(', ')
    : null;
export const getParkObjByCode = (code) => defaultData.parks.find((park) => park.code === code);
export const getTourerLengths = () => defaultData.tourerLengths;
export const getTourerLengthName = (value) => { var _a; return (_a = defaultData.tourerLengths.find((length) => value === length.code)) === null || _a === void 0 ? void 0 : _a.name; };
export const getTourerType = () => defaultData.tourerTypes;
export const getTourerTypeName = (value) => { var _a; return (_a = defaultData.tourerTypes.find((type) => type.code === value)) === null || _a === void 0 ? void 0 : _a.name; };
export const getGuestsObjByCode = (code) => defaultData.guests.find((guest) => guest.type === code);
export const getHolidayDates = () => defaultData.holidayDates;
export const getTouringDate = () => defaultData.touringDates;
export const checkAllParkInArray = (checkedParks, customArray) => {
    if (!checkedParks)
        return false;
    if (customArray) {
        return customArray.every((parkCode) => checkedParks.includes(parkCode));
    }
    const parkCodes = parks.map((park) => park.code);
    return parkCodes.every((parkCode) => checkedParks.includes(parkCode));
};
export const isSinglePark = (regions = []) => {
    if (regions.length === 1) {
        const [region = {}] = regions;
        const { parks = [] } = region;
        if (parks.length === 1) {
            return true;
        }
    }
    return false;
};
export const filterParksByDogsAllowed = (regions, allowDogs) => {
    if (allowDogs === undefined)
        return regions;
    return regions.map((region) => {
        return Object.assign(Object.assign({}, region), { parks: region.parks.filter((park) => park.allowDogs === allowDogs) });
    });
};
export const isParkDogFriendly = (parkCode) => {
    const park = getParkByCode(parkCode);
    if (!park)
        return false;
    return park.allowDogs;
};
export const getAllTouringParks = (type, size) => getListWithFilter(Object.assign({ touringAvailable: true }, (type ? { [type]: true } : {})), { type, size });
export const getAllRegionsWithParks = (filteredParks = []) => parks.reduce((obj, next) => {
    if (filteredParks.length > 0 && !filteredParks.includes(next.code)) {
        return obj;
    }
    if (obj[next.regionCode]) {
        return Object.assign(Object.assign({}, obj), { [next.regionCode]: Object.assign(Object.assign({}, obj[next.regionCode]), { parks: [...obj[next.regionCode].parks, next] }) });
    }
    return Object.assign(Object.assign({}, obj), { [next.regionCode]: {
            regionCode: next.regionCode,
            regionName: next.regionName,
            parks: [next],
        } });
}, {});
